import React, {Component} from "react";
import Garis from "./Garis";


class GarisSegitigaMandiri extends Component {

    renderSegitiga(){
        let segitiga = [];
        for (var i = 0; i < 12; i++) {
            segitiga.push(i);
        }

        return(
            segitiga.map((val, i) =>
                <div className="segitiga-mandiri" /> 
            )
        )
    }

    render() { 
        return (
            <>
                {this.renderSegitiga()}  
                <Garis />
            </>
        );
    }
}
 
export default GarisSegitigaMandiri;